function convertLocalToUTCDate(dateString) {
    if (!dateString) {
        return dateString
    }
    const dateObject = new Date(dateString)
    return Date.UTC(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate(), dateObject.getHours(), dateObject.getMinutes())
}
export default convertLocalToUTCDate;